var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import injectSheet from 'react-jss';

var styles = {
  svgIcon: {
    fill: 'currentColor'
  }
};

var SvgIcon = function SvgIcon(props) {
  var children = props.children,
      className = props.className,
      classes = props.classes,
      other = _objectWithoutProperties(props, ['children', 'className', 'classes']);

  return React.createElement(
    'svg',
    _extends({ className: classnames(className, classes.svgIcon) }, other),
    children
  );
};

SvgIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
} : {};

SvgIcon.defaultProps = {
  className: null,
  viewBox: '0 0 32 32',
  width: 32,
  height: 32
};

export default injectSheet(styles)(SvgIcon);